export default __webpack_public_path__ + "static/media/us-dc.701be2cb.svg";